import Ably from 'ably';

const user = JSON.parse(localStorage.getItem('user') || '{}');
let clientOptions: Ably.ClientOptions = {
  key: 'lTzGRw.Wl2erw:wiHEYEn3UP9t7MNl6R4isqdCYud_fEexqkV8DmV2Bcg',
  clientId: user._id || '123',
  echoMessages: false,
};
const ablyClient = new Ably.Realtime(clientOptions);

export default ablyClient;
